import { v4 as uuid } from 'uuid';
import { compact, map } from 'lodash';
import { toUUID } from '../../util/transform';
import HomeLoanReviewProductFee from './HomeLoanReviewProductFee';
import HomeLoanReviewProductReward from './HomeLoanReviewProductReward';
import HomeLoanProductCommission from './HomeLoanProductCommission';
import Ownership from '../finance/Ownership';
import type { IHomeLoanReviewProductSplit } from './HomeLoanReviewProductSplit.interface';

export default class HomeLoanReviewProductSplit implements IHomeLoanReviewProductSplit {
  id: string;
  idParent: string;
  idProduct: string;
  productName: string;
  totalLoanAmount: number;
  totalLoanAmountWithLmi: number;
  lmi: number;
  isEditLmi: boolean;
  isCapitalize: boolean;
  lep: number;
  interestRateOfProduct: number;
  interestRate: number;
  interestRateDiscount: number;
  revertRateOfProduct: number;
  revertRate: number;
  revertRateDiscount: number;
  comparisonRate: number;
  fixedTerm: number;
  introTerm: number;
  interestOnlyTerm: number;
  loanTerm: number;
  cashback: number;
  offsetBalance: number;
  monthlyOffsetContribution: number;
  absLendingPurposeCode: any;
  fees: HomeLoanReviewProductFee;
  rewards: HomeLoanReviewProductReward;
  commissions: HomeLoanProductCommission;
  ownership: Array<Ownership>;
  maximumBorrowing: number;
  selectedProduct: any;

  static build = (data: IHomeLoanReviewProductSplit) => new HomeLoanReviewProductSplit(data);
  static blank = () => new HomeLoanReviewProductSplit();

  /**
   * Constructor
   * @param {IHomeLoanReviewProductSplit} data
   */
  constructor(data?: IHomeLoanReviewProductSplit) {
    this.id = toUUID(data?.id) || uuid();
    this.idParent = data?.idParent || '';
    this.idProduct = data?.idProduct || '';
    this.productName = data?.productName || '';
    this.totalLoanAmount = parseFloat(data?.totalLoanAmount || 0);
    this.totalLoanAmountWithLmi = parseFloat(data?.totalLoanAmountWithLmi || 0);
    this.lmi = parseFloat(data?.lmi || 0);
    this.isEditLmi = data?.isEditLmi === true;
    this.isCapitalize = data?.isCapitalize === true;
    this.lep = parseFloat(data?.lep || 0);
    this.interestRateOfProduct = parseFloat(data?.interestRateOfProduct || 0);
    this.interestRate = parseFloat(data?.interestRate || 0);
    this.interestRateDiscount = parseFloat(data?.interestRateDiscount || 0);
    this.revertRateOfProduct = parseFloat(data?.revertRateOfProduct || 0);
    this.revertRate = parseFloat(data?.revertRate || 0);
    this.revertRateDiscount = parseFloat(data?.revertRateDiscount || 0);
    this.comparisonRate = parseFloat(data?.comparisonRate || 0);
    this.fixedTerm = parseFloat(data?.fixedTerm || 0);
    this.introTerm = parseFloat(data?.introTerm || 0);
    this.interestOnlyTerm = parseFloat(data?.interestOnlyTerm || 0);
    this.loanTerm = parseInt(data?.loanTerm || 0, 10);
    this.cashback = parseInt(data?.cashback || 0, 10);
    this.offsetBalance = parseInt(data?.offsetBalance || 0, 10);
    this.monthlyOffsetContribution = parseInt(data?.monthlyOffsetContribution || 0, 10);
    this.absLendingPurposeCode = data?.absLendingPurposeCode || undefined;
    this.fees = new HomeLoanReviewProductFee(data?.fees);
    this.rewards = new HomeLoanReviewProductReward(data?.rewards);
    this.commissions = new HomeLoanProductCommission(data?.commissions);
    this.ownership = map(compact(data?.ownership), (obj) => new Ownership(obj));
    this.maximumBorrowing = parseFloat(data?.maximumBorrowing || 0);
    this.selectedProduct = data?.selectedProduct || undefined;
  }
}
